<template>
	<v-dialog v-model="dialog" width="500px">
		<template v-slot:activator="{ on}">
			<v-btn large icon v-on="on" color="accent">
				<v-icon large>mdi-plus-circle</v-icon>
			</v-btn>	
		</template>
		<v-card>
			<v-card-title>Mitarbeiter Auswählen</v-card-title>
			<v-card-text>
				<v-select :items="users" v-model="user" item-text="display_name"
				item-value="id"></v-select>
			</v-card-text>
			<v-card-actions>
				<v-spacer></v-spacer>
				<v-btn color="primary" rounded @click="saveUser(subject)">Bestätigen</v-btn>
			</v-card-actions>
		</v-card>
	</v-dialog>

</template>

<style lang="less">
	
</style>

<script type="text/javascript">
	import Vuex from "vuex";
	// import - from "@/components/"
	export default {
		name: "SelectSubjectCollaborationUser", 
		props: {
			subject: {}			
		},
		data: () => {
			return {
				dialog: false,
				user: null
			}
		},
		// components: {

		// },
		computed: {
			...Vuex.mapState({
				users: state=>state.users, 
			})
		},
		methods: {
			saveUser(){
				this.$store.dispatch("assessments/saveSubjectUser", {subject: this.subject, user: this.user} )
				this.$emit('cancel')
			}
		}
		// created(){
			
		// }

	}
</script>"